// extracted by mini-css-extract-plugin
module.exports = {"reviewTitle":"UserRating_reviewTitle__3ioh6","reviewLink":"UserRating_reviewLink__y5efQ","star":"UserRating_star__2CHCs"};